import {isApolloError} from '@apollo/client'
import {isServerError} from './predicate'

export const fetchErrorMessage = (error: Error) => {
  if (isApolloError(error)) {
    const graphQLErrorMessage = error.graphQLErrors[0]?.message
    if (graphQLErrorMessage) {
      return graphQLErrorMessage
    }

    if (error.networkError && isServerError(error.networkError)) {
      // oxlint-disable-next-line typescript/no-explicit-any
      const networkErrorMessage = (error.networkError.result as Record<string, any>)['error']?.message
      if (networkErrorMessage) {
        return networkErrorMessage
      }
    }
  }

  return error.message
}
